<template>
  <div class="alert-wrapper">
    <div class="alert-wrapper-text">{{ getStateWithParam("notific_config_info1") }}</div>
    <div class="alert-btn">
      <button @click="goSettings()">
        {{getStateWithParam("notific_config_info2")}}
        <v-icon color="primary">settings</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseAlertCard",
  data() {
    return {
      alert: true
    };
  },
  methods: {
    goSettings() {
      this.$router.push({
        name: "settings_label",
        path: "/setting"
      });
    },

    getStateWithParam(param) {
      return this.$store.getters.getLanguageParameters(param);
    }
  }
};
</script>

<style lang="scss" scoped>
.alert-wrapper {
  .alert-btn {
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
    button {
      display: flex;
      align-items: center;
      box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
      padding: 8px;
      border-radius: 5px;
      &:focus {
        outline: none;
      }
      .v-icon {
        padding-left: 5px;
      }
    }
  }
}
</style>
